import { c as _c } from "react/compiler-runtime";
import CollectionsMenuIcon from "@/components/common/icons/CollectionsMenuIcon";
import type { SidebarSection } from "@/components/navigation/navTypes";
import { shouldHideSubscriptions } from "@/components/user/layout/userPageVisibility";
import { AboutSection } from "@/types/enums";
import { DocumentTextIcon, UsersIcon, WrenchIcon } from "@heroicons/react/24/outline";
import { useMemo, type ComponentType } from "react";
export function useSidebarSections(appWalletsSupported, isIos, country) {
  const $ = _c(53);
  let t0;
  if ($[0] !== country || $[1] !== isIos) {
    t0 = shouldHideSubscriptions({
      capacitorIsIos: isIos,
      country
    });
    $[0] = country;
    $[1] = isIos;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const hideSubscriptions = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      name: "Identities",
      href: "/network"
    }, {
      name: "Activity",
      href: "/network/activity"
    }, {
      name: "Groups",
      href: "/network/groups"
    }, {
      name: "NFT Activity",
      href: "/nft-activity"
    }, {
      name: "Memes Calendar",
      href: "/meme-calendar"
    }, {
      name: "TDH",
      href: "/network/tdh"
    }, {
      name: "xTDH",
      href: "/xtdh"
    }];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: "network",
      name: "Network",
      icon: UsersIcon,
      items: t1,
      subsections: [{
        name: "Metrics",
        items: [{
          name: "Health",
          href: "/network/health"
        }, {
          name: "Definitions",
          href: "/network/definitions"
        }, {
          name: "Levels",
          href: "/network/levels"
        }, {
          name: "Network Stats",
          href: "/network/health/network-tdh"
        }]
      }]
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      key: "collections",
      name: "Collections",
      icon: CollectionsMenuIcon,
      items: [{
        name: "The Memes",
        href: "/the-memes"
      }, {
        name: "6529 Gradient",
        href: "/6529-gradient"
      }, {
        name: "NextGen",
        href: "/nextgen"
      }, {
        name: "Meme Lab",
        href: "/meme-lab"
      }, {
        name: "ReMemes",
        href: "/rememes"
      }],
      subsections: []
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      name: "NFT Delegation",
      items: [{
        name: "Delegation Center",
        href: "/delegation/delegation-center"
      }, {
        name: "Wallet Architecture",
        href: "/delegation/wallet-architecture"
      }, {
        name: "Delegation FAQs",
        href: "/delegation/delegation-faq"
      }, {
        name: "Consolidation Use Cases",
        href: "/delegation/consolidation-use-cases"
      }, {
        name: "Wallet Checker",
        href: "/delegation/wallet-checker"
      }]
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== hideSubscriptions) {
    t6 = hideSubscriptions ? [] : [{
      name: "Subscriptions Report",
      href: "/tools/subscriptions-report"
    }];
    $[8] = hideSubscriptions;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      name: "Memes Accounting",
      href: "/meme-accounting"
    };
    t8 = {
      name: "Memes Gas",
      href: "/meme-gas"
    };
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6) {
    t9 = {
      name: "The Memes Tools",
      items: [...t6, t7, t8]
    };
    $[12] = t6;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== appWalletsSupported) {
    t10 = appWalletsSupported ? [{
      name: "App Wallets",
      href: "/tools/app-wallets"
    }] : [];
    $[14] = appWalletsSupported;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  let t12;
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      name: "API",
      href: "/tools/api"
    };
    t12 = {
      name: "EMMA",
      href: "/emma"
    };
    t13 = {
      name: "Block Finder",
      href: "/tools/block-finder"
    };
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t11 = $[16];
    t12 = $[17];
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t10) {
    t14 = {
      name: "Other Tools",
      items: [...t10, t11, t12, t13]
    };
    $[19] = t10;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      name: "Open Data",
      href: "/open-data"
    };
    t16 = {
      name: "Network Metrics",
      href: "/open-data/network-metrics"
    };
    $[21] = t15;
    $[22] = t16;
  } else {
    t15 = $[21];
    t16 = $[22];
  }
  let t17;
  if ($[23] !== hideSubscriptions) {
    t17 = hideSubscriptions ? [] : [{
      name: "Meme Subscriptions",
      href: "/open-data/meme-subscriptions"
    }];
    $[23] = hideSubscriptions;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  let t19;
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      name: "Rememes",
      href: "/open-data/rememes"
    };
    t19 = {
      name: "Team",
      href: "/open-data/team"
    };
    t20 = {
      name: "Royalties",
      href: "/open-data/royalties"
    };
    $[25] = t18;
    $[26] = t19;
    $[27] = t20;
  } else {
    t18 = $[25];
    t19 = $[26];
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t17) {
    t21 = {
      name: "Open Data",
      items: [t15, t16, ...t17, t18, t19, t20]
    };
    $[28] = t17;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== t14 || $[31] !== t21 || $[32] !== t9) {
    t22 = {
      key: "tools",
      name: "Tools",
      icon: WrenchIcon,
      items: t4,
      subsections: [t5, t9, t14, t21]
    };
    $[30] = t14;
    $[31] = t21;
    $[32] = t9;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = [{
      name: "GDRC1",
      href: `/about/${AboutSection.GDRC1}`
    }];
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      name: "The Memes",
      href: `/about/${AboutSection.MEMES}`
    };
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== hideSubscriptions) {
    t25 = hideSubscriptions ? [] : [{
      name: "Subscriptions",
      href: `/about/${AboutSection.SUBSCRIPTIONS}`
    }];
    $[36] = hideSubscriptions;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  let t27;
  let t28;
  let t29;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      name: "Minting",
      href: `/about/${AboutSection.MINTING}`
    };
    t27 = {
      name: "Nakamoto Threshold",
      href: `/about/${AboutSection.NAKAMOTO_THRESHOLD}`
    };
    t28 = {
      name: "Meme Lab",
      href: `/about/${AboutSection.MEME_LAB}`
    };
    t29 = {
      name: "Gradients",
      href: `/about/${AboutSection.GRADIENTS}`
    };
    $[38] = t26;
    $[39] = t27;
    $[40] = t28;
    $[41] = t29;
  } else {
    t26 = $[38];
    t27 = $[39];
    t28 = $[40];
    t29 = $[41];
  }
  let t30;
  if ($[42] !== t25) {
    t30 = {
      name: "NFTs",
      items: [t24, ...t25, t26, t27, t28, t29]
    };
    $[42] = t25;
    $[43] = t30;
  } else {
    t30 = $[43];
  }
  let t31;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      name: "NFT Delegation",
      items: [{
        name: "About NFTD",
        href: `/about/${AboutSection.NFT_DELEGATION}`
      }, {
        name: "Primary Address",
        href: `/about/${AboutSection.PRIMARY_ADDRESS}`
      }]
    };
    $[44] = t31;
  } else {
    t31 = $[44];
  }
  let t32;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      name: "6529 Capital",
      items: [{
        name: "About 6529 Capital",
        href: "/capital"
      }, {
        name: "Company Portfolio",
        href: "/capital/company-portfolio"
      }, {
        name: "NFT Fund",
        href: "/capital/fund"
      }]
    };
    $[45] = t32;
  } else {
    t32 = $[45];
  }
  let t33;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      name: "Support",
      items: [{
        name: "FAQ",
        href: `/about/${AboutSection.FAQ}`
      }, {
        name: "Apply",
        href: `/about/${AboutSection.APPLY}`
      }, {
        name: "Contact Us",
        href: `/about/${AboutSection.CONTACT_US}`
      }]
    };
    $[46] = t33;
  } else {
    t33 = $[46];
  }
  let t34;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      name: "Resources",
      items: [{
        name: "Data Decentralization",
        href: `/about/${AboutSection.DATA_DECENTR}`
      }, {
        name: "ENS",
        href: `/about/${AboutSection.ENS}`
      }, {
        name: "License",
        href: `/about/${AboutSection.LICENSE}`
      }, {
        name: "Release Notes",
        href: `/about/${AboutSection.RELEASE_NOTES}`
      }]
    };
    $[47] = t34;
  } else {
    t34 = $[47];
  }
  let t35;
  if ($[48] !== t30) {
    t35 = {
      key: "about",
      name: "About",
      icon: DocumentTextIcon,
      items: t23,
      subsections: [t30, t31, t32, t33, t34]
    };
    $[48] = t30;
    $[49] = t35;
  } else {
    t35 = $[49];
  }
  let t36;
  if ($[50] !== t22 || $[51] !== t35) {
    t36 = [t2, t3, t22, t35];
    $[50] = t22;
    $[51] = t35;
    $[52] = t36;
  } else {
    t36 = $[52];
  }
  return t36;
}
export function useSectionMap(sections) {
  const $ = _c(2);
  let t0;
  if ($[0] !== sections) {
    t0 = new Map(sections.map(_temp));
    $[0] = sections;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(section) {
  return [section.key, section];
}
export interface SidebarPageEntry {
  name: string;
  href: string;
  section: string;
  subsection?: string | undefined;
  icon?: ComponentType<{
    className?: string | undefined;
  }> | undefined;
}
export function mapSidebarSectionsToPages(sections: SidebarSection[]): SidebarPageEntry[] {
  return sections.flatMap(section => {
    const sectionIcon = section.icon;
    const sectionItems: SidebarPageEntry[] = section.items.map(item => ({
      name: item.name,
      href: item.href,
      section: section.name,
      icon: sectionIcon
    }));
    const subsectionItems = section.subsections?.flatMap(subsection => subsection.items.map(item => ({
      name: item.name,
      href: item.href,
      section: section.name,
      subsection: subsection.name,
      icon: sectionIcon
    }))) ?? [];
    return [...sectionItems, ...subsectionItems];
  });
}